import { create } from "zustand";

export const useLocalsListStore = create((set) => ({
  localesList: [],
  setlocalesList: (list: any) => set(() => ({ localesList: list })),
}));
